var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.viewMode === "list"
    ? _c(
        "section",
        { staticClass: "bic-list" },
        _vm._l(_vm.filteredItems, function (item) {
          return _c(
            "div",
            { key: item.id, staticClass: "bic-list__bic-item-wrapper" },
            [
              _c("BicItem", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value:
                      item.code !== _vm.alternateBicSource ||
                      _vm.alternateBicLoading === true ||
                      !_vm.alternateBic,
                    expression:
                      "item.code !== alternateBicSource || alternateBicLoading === true || !alternateBic",
                  },
                ],
                attrs: {
                  item: item,
                  selected: _vm.selectedIds.indexOf(item.id) !== -1,
                  addToWatchlist: () => _vm.addToWatchlist(item),
                  removeFromWatchlist: () =>
                    _vm.removeFromWatchlist({ id: item.id }),
                  showHelp: _vm.itemsHelp === item.code,
                  toggleBicsHelp: () => _vm.toggleBicsHelp({ code: item.code }),
                  getAlternateBicForSource: (payload) =>
                    _vm.getAlternateBic({ ...payload, source_code: item.code }),
                },
              }),
              _vm._v(" "),
              item.code === _vm.alternateBicSource &&
              _vm.alternateBicLoading === false &&
              _vm.alternateBic
                ? _c("BicItemAlternate", {
                    attrs: {
                      item: _vm.alternateBic,
                      clearAlternateBic: _vm.clearAlternateBic,
                    },
                  })
                : _vm._e(),
            ],
            1
          )
        }),
        0
      )
    : _vm.viewMode === "grid"
    ? _c(
        "section",
        { staticClass: "bic-list bic-list--grid u-clearfix" },
        _vm._l(3, function (n) {
          return _c(
            "div",
            { key: n, staticClass: "bic-list__column" },
            _vm._l(_vm.filteredItemsColumn(n), function (item) {
              return _c(
                "div",
                { key: item.id, staticClass: "bic-list__bic-item-wrapper" },
                [
                  _c("BicItem", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          item.code !== _vm.alternateBicSource ||
                          _vm.alternateBicLoading === true ||
                          !_vm.alternateBic,
                        expression:
                          "item.code !== alternateBicSource || alternateBicLoading === true || !alternateBic",
                      },
                    ],
                    attrs: {
                      item: item,
                      selected: _vm.selectedIds.indexOf(item.id) !== -1,
                      addToWatchlist: () => _vm.addToWatchlist(item),
                      removeFromWatchlist: () =>
                        _vm.removeFromWatchlist({ id: item.id }),
                      showHelp: _vm.itemsHelp === item.code,
                      toggleBicsHelp: () =>
                        _vm.toggleBicsHelp({ code: item.code }),
                      getAlternateBicForSource: (payload) =>
                        _vm.getAlternateBic({
                          ...payload,
                          source_code: item.code,
                        }),
                    },
                  }),
                  _vm._v(" "),
                  item.code === _vm.alternateBicSource &&
                  _vm.alternateBicLoading === false &&
                  _vm.alternateBic
                    ? _c("BicItemAlternate", {
                        attrs: {
                          item: _vm.alternateBic,
                          clearAlternateBic: _vm.clearAlternateBic,
                        },
                      })
                    : _vm._e(),
                ],
                1
              )
            }),
            0
          )
        }),
        0
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }